module.exports = __webpack_public_path__ + "img/sala-estar.ec1d4e34.svg";